// Author YuJiaBei
// Date 2021-12-15 15:12:09

class RepairPlan {
constructor({
        id = null,
        parentId = '',
        seq = '',
        repairSpecializedTypeId = '',
        repairPlanCategoryId = '',
        status = '',
        workOrderCode = '',
        emLocationCode = '',
        name = '',
        repairConstructionUnitId = '',
        responsiblePerson = '',
        responsiblePersonRealName = '',
        guardian = '',
        guardianRealName = '',
        reviewer = '',
        reviewerRealName = '',
        safetyPrecautions = '',
        planStartTime = '',
        planEndTime = '',
        actualStartTime = '',
        actualEndTime = '',
        planDuration = '',
        actualDuration = '',
        approvalTime = '',
        descriptionPersonChange = '',
        descriptionDelay = '',
        workSummary = '',
        comment = '',
        attachmentStart = '',
        attachmentFinish = '',
        attachmentStartList = '',
        attachmentFinishList = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.seq = seq;
    this.repairSpecializedTypeId = repairSpecializedTypeId;
    this.repairPlanCategoryId = repairPlanCategoryId;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.emLocationCode = emLocationCode;
    this.name = name;
    this.repairConstructionUnitId = repairConstructionUnitId;
    this.responsiblePerson = responsiblePerson;
    this.responsiblePersonRealName = responsiblePersonRealName;
    this.guardian = guardian;
    this.guardianRealName = guardianRealName;
    this.reviewer = reviewer;
    this.reviewerRealName = reviewerRealName;
    this.safetyPrecautions = safetyPrecautions;
    this.planStartTime = planStartTime;
    this.planEndTime = planEndTime;
    this.actualStartTime = actualStartTime;
    this.actualEndTime = actualEndTime;
    this.planDuration = planDuration;
    this.actualDuration = actualDuration;
    this.approvalTime = approvalTime;
    this.descriptionPersonChange = descriptionPersonChange;
    this.descriptionDelay = descriptionDelay;
    this.workSummary = workSummary;
    this.comment = comment;
    this.attachmentStart = attachmentStart;
    this.attachmentFinish = attachmentFinish;
    this.attachmentStartList = attachmentStartList;
    this.attachmentFinishList = attachmentFinishList;
}
}

function newEntity() {
return new RepairPlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.repair.repairPlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
            key: 'workOrderCode',
            label: 'label.em.repair.repairPlan.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'name',
            label: 'label.em.repair.repairPlan.grid.name',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
        key: 'repairSpecializedTypeName',
        label: 'label.em.repair.repairPlan.grid.repairSpecializedTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'repairPlanCategoryName',
        label: 'label.em.repair.repairPlan.grid.repairPlanCategoryName',
        sortable: true,
        form: {
        type: 'input'
        }
        },

        {
        key: 'emLocationCode',
        label: 'label.em.repair.repairPlan.grid.emLocationCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.repair.repairPlan.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'guardianRealName',
        label: 'label.em.repair.repairPlan.grid.guardianRealName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'authorRealName',
        label: 'label.em.repair.repairPlan.grid.authorRealName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerRealName',
        label: 'label.em.repair.repairPlan.grid.reviewerRealName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'safetyPrecautions',
        label: 'label.em.repair.repairPlan.grid.safetyPrecautions',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planStartTime',
        label: 'label.em.repair.repairPlan.grid.planStartTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planEndTime',
        label: 'label.em.repair.repairPlan.grid.planEndTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualStartTime',
        label: 'label.em.repair.repairPlan.grid.actualStartTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualEndTime',
        label: 'label.em.repair.repairPlan.grid.actualEndTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'descriptionPersonChange',
        label: 'label.em.repair.repairPlan.grid.descriptionPersonChange',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'descriptionDelay',
        label: 'label.em.repair.repairPlan.grid.descriptionDelay',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workSummary',
        label: 'label.em.repair.repairPlan.grid.workSummary',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'comment',
        label: 'label.em.repair.repairPlan.grid.comment',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'attachmentStartList',
        label: 'label.em.repair.repairPlan.grid.attachmentStartList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'attachmentFinishList',
        label: 'label.em.repair.repairPlan.grid.attachmentFinishList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.repair.repairPlan.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.repair.repairPlan.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    parentIdFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    seqFilter : '',
    repairSpecializedTypeIdFilter : '',
    repairPlanCategoryIdFilter : '',
    statusFilter : '',
    workOrderCodeFilter : '',
    emLocationCodeFilter : '',
    nameFilter : '',
    repairConstructionUnitIdFilter : '',
    responsiblePersonFilter : '',
    responsiblePersonRealNameFilter : '',
    guardianFilter : '',
    guardianRealNameFilter : '',
    authorFilter : '',
    authorRealNameFilter : '',
    reviewerFilter : '',
    reviewerRealNameFilter : '',
    planStartTimeRteFilter : '',
    planStartTimeLteFilter : '',
    planEndTimeRteFilter : '',
    planEndTimeLteFilter : '',
    actualStartTimeRteFilter : '',
    actualStartTimeLteFilter : '',
    actualEndTimeRteFilter : '',
    actualEndTimeLteFilter : '',
    descriptionDelayFilter : '',
    workflowQueryTypeFilter : '',
    emAclDeptIdFilter : '',
    emAclDeptNameFilter : '',
    emAclDeptNodeCodeFilter : '',
    emAclDeptNodeCodeNameFilter : '',
    emArchLocCodeFilter : '',
    emArchLocNodeCodeFilter : '',
    emArchLocNodeCodeNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'repairSpecializedTypeIdFilter',
        label: 'label.em.repair.repairPlan.filter.repairSpecializedTypeId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'repairSpecializedType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'repairPlanCategoryIdFilter',
        label: 'label.em.repair.repairPlan.filter.repairPlanCategoryId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'repairPlanCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.repair.repairPlan.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'RepairPlan',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.repair.repairPlan.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.repair.repairPlan.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'guardianRealNameFilter',
        label: 'label.em.repair.repairPlan.filter.guardianRealName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'authorRealNameFilter',
        label: 'label.em.repair.repairPlan.filter.authorRealName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'reviewerRealNameFilter',
        label: 'label.em.repair.repairPlan.filter.reviewerRealName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'planStartTimeRteFilter',
        label: 'label.em.repair.repairPlan.filter.planStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'planStartTimeLteFilter',
        label: 'label.em.repair.repairPlan.filter.planStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'planEndTimeRteFilter',
        label: 'label.em.repair.repairPlan.filter.planEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'planEndTimeLteFilter',
        label: 'label.em.repair.repairPlan.filter.planEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'actualStartTimeRteFilter',
        label: 'label.em.repair.repairPlan.filter.actualStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'actualStartTimeLteFilter',
        label: 'label.em.repair.repairPlan.filter.actualStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'actualEndTimeRteFilter',
        label: 'label.em.repair.repairPlan.filter.actualEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'actualEndTimeLteFilter',
        label: 'label.em.repair.repairPlan.filter.actualEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.repair.repairPlan.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.repair.repairPlan.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.repair.repairPlan.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.repair.repairPlan.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'repairSpecializedTypeId',
        label: 'label.em.repair.repairPlan.entity.repairSpecializedTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'repairSpecializedType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'repairPlanCategoryId',
        label: 'label.em.repair.repairPlan.entity.repairPlanCategoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'repairPlanCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'emLocationCode',
        label: 'label.em.repair.repairPlan.entity.emLocationCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'name',
        label: 'label.em.repair.repairPlan.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'repairConstructionUnitId',
        label: 'label.em.repair.repairPlan.entity.repairConstructionUnitId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'responsiblePersonRealName',
        label: 'label.em.repair.repairPlan.entity.responsiblePersonRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"responsiblePerson":"loginName"}'
                }
        },
        {
        key: 'guardianRealName',
        label: 'label.em.repair.repairPlan.entity.guardianRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"guardian":"loginName"}'
                }
        },
        {
        key: 'reviewerRealName',
        label: 'label.em.repair.repairPlan.entity.reviewerRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"reviewer":"loginName"}'
                }
        },
        {
        key: 'safetyPrecautions',
        label: 'label.em.repair.repairPlan.entity.safetyPrecautions',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'planStartTime',
        label: 'label.em.repair.repairPlan.entity.planStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'planEndTime',
        label: 'label.em.repair.repairPlan.entity.planEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'actualStartTime',
        label: 'label.em.repair.repairPlan.entity.actualStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'actualEndTime',
        label: 'label.em.repair.repairPlan.entity.actualEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'descriptionPersonChange',
        label: 'label.em.repair.repairPlan.entity.descriptionPersonChange',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descriptionDelay',
        label: 'label.em.repair.repairPlan.entity.descriptionDelay',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'workSummary',
        label: 'label.em.repair.repairPlan.entity.workSummary',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'comment',
        label: 'label.em.repair.repairPlan.entity.comment',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'attachmentStartList',
        label: 'label.em.repair.repairPlan.entity.attachmentStart',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachmentStart'
                }
        },
        {
        key: 'attachmentFinishList',
        label: 'label.em.repair.repairPlan.entity.attachmentFinish',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachmentFinish'
                }
        }
]

export {RepairPlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
